<template>
  <div class="TopicList">
    <div class="inner_center _hide">
      <div class="timeline-box">
        <div class="timeline-map">
          <div
            :style="'height:' + ( viewWidth * (list.length-1)) + 'px'"
            class="line"/>
        </div>

        <div
          v-for="(vo,idx) in list"
          :key="idx"
          class="timeline-item"
        >
          <div
            class="timeline-map-item">
            <span class="time">{{ vo.online_time }}</span>
            <span class="ball ball-update">
              <i />
            </span>
          </div>

          <div class="pic-info">
            <a
              :href="vo.link"
              target="_blank"
              class="pic-title overflow-one">{{ vo.title }}</a>
            <div
              class="title-new">
              <i class="icon_pic" />
              <div class="text-num">{{ vo.picture_total }}张</div>
            </div>

            <SubscriptionBtn :topic-item="vo" />

          </div>
          <div class="pic-list">

            <div
              class="pic-content"

              ref="picContent">

              <div
                :class=" [ vo.isSlide ? 'ON' : 'NO' ] "
                class="img-wrap">
                <div
                  v-for="(item,index) of vo.pictures"
                  :key="item.uniq_id"
                  ref="imgBox"
                  class="img-box"

                >
                  <NavigationTo :path="vo.link">
                    <img
                      slot="content"
                      v-lazy="IMG_BASE_URL +item.proto_pic + '?x-oss-process=image/resize,w_279/quality,q_90/sharpen,100'">
                  </NavigationTo>
                </div>
              </div>

            </div>
            <i
              @click.stop="add(vo, idx)"
              class="iconfont icon-a-arrowrightbold icon-a-arrowrightbold2"/>

            <i
              @click.stop="add(vo, idx)"
              class="iconfont icon-a-arrowrightbold"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IMG_BASE_URL, MATERIAL_DETAIL, MATERIAL_LIST} from "@/constant/PATH";
import SubscriptionBtn from '@/components/topic/subscription-btn';


export default {
  name: "TopicList",
  components:{
    SubscriptionBtn
  },
  props:{
    list:{
      type: Array,
      default: ()=>[]
    }
  },
  data() {
    return {
      viewWidth: '',
      MATERIAL_DETAIL,
      IMG_BASE_URL,
      MATERIAL_LIST,
    }
  },
  mounted() {
    this.initViewWidth();
    window.onresize = () => {
      this.initViewWidth();
    }
  },
  methods: {
    initViewWidth() {

      this.viewWidth = document.body.clientWidth > 1440 ? (334 + 48) : (281 + 40)
    },

    add(vo,idx){
      if (!vo.isSlide){
        vo.isSlide = true
      }else{
        vo.isSlide = !vo.isSlide
      }

      this.$set(this.list,idx,vo);
      console.log(vo)
      /*console.log(111)

      console.log(this.$refs.imgBox[idx].style.left)
      let left = this.$refs.imgBox[idx].offsetLeft
      console.log(left)

      if (left == 0){
        // this.$refs.picContent[idx].style.left = this.$refs.picContent[idx].offsetWidth
        this.$refs.picContent[idx].style.left =  - this.$refs.picContent[idx].offsetWidth + 'px';
      }else{
        this.$refs.picContent[idx].style.left = 0 + 'px';
      }*/
    }
  },
  destroyed() {
    window.onresize = null;
  },
}
</script>

<style lang="scss" scoped>
.timeline-box {
  width: 1256px;
  margin-left: 184px;
  position: relative;

  .timeline-map {
    border-radius: 2px;
    @include Position(1, 5, -52px, 0px);
    @include Position(1, 5, -52px, 167px);
    //width: 184px;

    .line {
      content: '';
      display: inline-block;
      width: 4px;
      //height: 1536px;
      box-shadow: inset -3px -3px 8px 0px #C8D0E7, inset 3px 3px 8px 0px rgba(255, 255, 255, 0.5);
      border-radius: 2px;
      //@include Position(1, 2, 52px, 0);
      z-index: -1;
    }


  }

  .timeline-item {
    width: 1256px;
    height: 334px;
    border-radius: 14px;
    border: 1px solid #ECEFF6;
    padding: 41px 32px 31px 48px;
    box-sizing: border-box;
    margin-bottom: 48px;
    display: flex;
    justify-content: space-between;
    position: relative;
    transition: all 0.5s ease-in;


    .timeline-map-item {
      display: flex;
      width: 184px;
      position: absolute;
      top: 50%;
      left: -181px;
      transform: translateY(-50%);

      .time {
        height: 18px;
        font-size: 13px;
        color: #0A2540;
        line-height: 18px;
        //margin-right: 20px;
        width: 120px;
      }

      .ball {
        width: 20px;
        height: 20px;
        background: linear-gradient(225deg, #65EADE 0%, #35D0BA 100%);
        box-shadow: 0px 2px 4px 0px rgba(53, 208, 186, 0.6);
        border-radius: 50%;

        &.ball-update {
          background: linear-gradient(228deg, #FE7E7E 0%, #F94D67 100%);
          box-shadow: 0px 2px 4px 0px rgba(249,81,105,0.43);
          @include LayoutFlex(1);

          i{
            display: inline-block;
            width: 8px;
            height: 8px;
            background: linear-gradient(134deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.1) 100%);
            box-shadow: 0px 2px 40px -1px rgba(249,81,105,0.2);
            border: 1px solid;
            border-image: linear-gradient(136deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0), rgba(248, 204, 68, 0), rgba(255, 255, 255, 0.5)) 0 0 ;
            backdrop-filter: blur(10px);
            transform: scale(0.8);
            border-radius: 50%;
          }
        }
      }

    }

    .pic-info {
      .pic-title{
        display: inline-block;
        width: 260px;
        font-size: 24px;
        font-weight: bold;
        color: #424866;
        line-height: 31px;
        letter-spacing: 2px;
        margin-bottom: 12px;
        margin-top: 20px;
        //transition: all 0.6s ease-in;
        @include ElementHover(#F94D67,'');
      }

      .title-new {
        display: flex;
        margin-bottom: 97px;
        .icon_pic{
          @include BgImage(22px,22px,'topic/index/icon_pic.svg');
          margin-right: 8px;
        }

        .text-num {
          font-size: 16px;
          color: #424866;
          line-height: 21px;
          letter-spacing: 1px;
        }
      }


      .subscription{
        width: 176px;
        height: 48px;
        border-radius: 24px;
        position: relative;

        &:after{
          content: '';
          display: inline-block;
          width: 1px;
          height: 14px;
          background: rgba(255,255,255,0.5);
          border-radius: 1px;
          @include Position(1,5,68px,17px);
        }

        .txt-subscription{
          font-size: 14px;
          color: #FFFFFF;
          margin-left: 83px;
          line-height: 48px;
        }




        &.subscription-topic{
          background: linear-gradient(44deg, #FE7E7E 0%, #F94D67 100%);
          line-height: 48px;
          @include ElementHover('', linear-gradient(44deg, #F94D67 0%, #FE7E7E 100%));

          .icon-sub{
            display: inline-block;
            font-size: 22px;
            color: #FFFFFF;
            @include Position(1,5,32px,0px);

          }

          .txt-subscription{
            font-size: 14px;
            color: #FFFFFF;
            margin-left: 83px;
            line-height: 48px;
          }

        }

        &.no-subscription-topic{
          background: #FFFFFF;
          border: 1px solid #ECEFF6;

          @include ElementHover('', #F7F9FD);

          &:after{
            background: rgba(66,72,102,0.15);
          }

          .txt-subscription{
            color: #7A7E93;
          }
          .icon_subscription{
            @include BgImage(22px,22px,'topic/index/icon_subscription.svg');
            @include Position(1,5,32px,13px);

          }
        }
      }



    }

    .pic-list {
      width: 860px;
      //overflow: hidden;
      height: 260px;
      position: relative;
      .pic-content{

        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

        .img-wrap{
          display: flex;
          flex-wrap: nowrap;
          position: absolute;
          left: 0;
          top: 0;
          transition: all 0.5s ease;

          &.NO{
            left: 0;
          }
          &.ON{
            left: -878px;
          }

        }
      }

      .img-box {
        display: inline-block;
        width: 200px;
        flex-shrink: 0;
        height: 262px;
        border-radius: 14px;
        margin-left: 20px;
        //background-color: #CCCCCC;
        overflow: hidden;
        transition: all 0.5s ease-in-out;

        &:first-child{
          margin-left: 0;
        }



        img {
          display: inline-block;
          width: 100%;
          height: 100%;
          border-radius: 14px;
          transition: all 0.5s ease-in-out;
        }

        @include ElementHover('', '') {
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 26, 0.12) !important;
          img {
            transform: scale(1.1);
          }
        }


      }

      .icon-a-arrowrightbold {
        width: 36px;
        height: 36px;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(10, 37, 64, 0.1000);
        @include Position(1, 2, -18px, 50%);
        transform: translateY(-50%);
        border-radius: 50%;
        font-size: 20px;
        line-height: 36px;
        text-align: center;
        z-index: 2;
        cursor: pointer;

        @include ElementHover(#FFFFFF, #F94D67);

        &.icon-a-arrowrightbold2 {
          @include Position(1, 4, -18px, 50%);
          transform: translateY(-50%) rotate(180deg);

        }
      }
    }
  }


}

@include Screen(1) {

  .timeline-box {
    transition: all 0.5s ease-in;
    width: 1068px;

    .timeline-map {
      transition: all 0.5s ease-in;
      @include Position(1, 5, -52px, 140.5px);
    }

    .timeline-item {
      width: 1016px;
      height: 281px;
      margin-bottom: 40px;
      padding-left: 48px;

      .pic-list {
        transition: all 0.5s ease-in-out;
        position: relative;
        width: 688px;
        height: 209px;

        .pic-content{
          display: flex;
          flex-wrap: nowrap;
          width: 688px;

          .img-wrap{
            &.NO{
              left: 0;
            }
            &.ON{
              left: -704px;
            }

          }
        }

        .img-box {

          width: 160px;
          height: 209px;
          margin-left: 16px;
        }
      }

      .pic-info {
        .pic-title{
          width: 200px;
          margin-top: 8px;
        }
        .illus-num {
          transition: all 0.5s ease-in;
          margin-bottom: 69px;
        }

        .title-new {
          font-size: 22px;
          margin-bottom: 76px;
        }
      }

    }
  }
}
</style>
